import React from 'react';
import { Reveal } from './ui/Reveal';
import { BONUS_TOTAL, bonuses } from '../data/content';

/* Mismos colores que los bonos en la imagen del pack */
const BONO_COLORS = ['bg-red-600 text-white', 'bg-blue-600 text-white', 'bg-green-600 text-white', 'bg-orange-500 text-white', 'bg-purple-600 text-white'];
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-white text-noche" data-id="element-28" data-mp="qw5vll97u1vc">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-29" data-mp="14rzwpi3qzmxw">
        <h2 id="bonos" className="font-display text-4xl uppercase leading-none tracking-wide sm:text-6xl" data-id="element-30" data-mp="ztg97d9ia33f">
          <span className="rounded-lg bg-naranja px-2 py-0.5 text-white" data-id="element-31" data-mp="1eim973g63xcd">
            5 Bonos incluidos
          </span>
        </h2>
        <p className="mx-auto mt-2.5 max-w-xl text-sm leading-snug text-noche/80" data-id="element-32" data-mp="1njspbbewn653">
          Y además recibes 5 recursos prácticos —{' '}
          <strong className="font-extrabold text-verde-dark" data-id="element-33" data-mp="1jjryssej74ho">
            GRATIS con tu compra.
          </strong>
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-34" data-mp="3pseqkgs05sfv">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className={`flex h-full flex-col overflow-hidden rounded-xl border-2 border-noche bg-ciencia-light text-left ${i === bonuses.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-35" data-mp="3ts6ziulb60lr" data-mpi={i}>
              <span className={`px-2.5 py-1 font-sub text-sm font-extrabold ${BONO_COLORS[i]}`} data-id="element-36" data-mp="gldo1g1f4h4u">
                Bono {i + 1} — Gratis
              </span>
              <div className="flex flex-1 flex-col p-2.5" data-id="element-37" data-mp="lcnbc9zhv8dk">
                <h3 className="font-sub text-sm font-extrabold leading-tight text-noche" data-id="element-38" data-mp="qbq52ya0xs68">
                  {bono.title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-noche/80 sm:text-sm" data-id="element-39" data-mp="vbumcqiraqxi">
                  {bono.desc}
                </p>
                <p className="mt-auto pt-1.5 text-xs font-bold text-noche/80" data-id="element-40" data-mp="al8ol2wiy5gf">
                  Valor:{' '}
                  <span className="text-red-600 line-through decoration-2" data-id="element-41" data-mp="5me7q6i4aqyy">
                    {bono.value}
                  </span>
                </p>
              </div>
            </Reveal>)}
        </ul>

        <div className="mt-3 rounded-xl border-2 border-dashed border-oro bg-noche px-3 py-2.5 leading-tight" data-id="element-42" data-mp="fk20ws02rqf0">
          <p className="font-sub text-base font-bold text-white" data-id="element-43" data-mp="tap3iv8yi0gd">
            💰 Valor total de los 5 bonos:{' '}
            <span className="text-white/80 line-through decoration-red-500 decoration-2" data-id="element-44" data-mp="oc3z0jmo8um4">
              {BONUS_TOTAL}
            </span>
          </p>
          <p className="mt-1 font-display text-xl uppercase tracking-wide text-oro" data-id="element-45" data-mp="yb2z3dtdfhxi">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}